/**
 * account-modules.ts — Các mục của Cài đặt cá nhân (/account/<id>), CHỈ dữ liệu (không JSX).
 * Dùng chung cho trang (account-page.tsx gắn phần vẽ) và bảng lệnh ⌘K.
 */
import { Bell, History, Keyboard, Palette, UserRound, type LucideIcon } from 'lucide-react'
import { i18n } from '@/lib/i18n'

export interface AccountModuleMeta {
  id: string
  label: string
  icon: LucideIcon
  description: string
}

export const ACCOUNT_MODULES_META: AccountModuleMeta[] = [
  {
    id: 'profile', icon: UserRound,
    get label() { return i18n.t('accountPages:modules.profile.label') },
    get description() { return i18n.t('accountPages:modules.profile.description') },
  },
  {
    id: 'login-history', icon: History,
    get label() { return i18n.t('accountPages:modules.loginHistory.label') },
    get description() { return i18n.t('accountPages:modules.loginHistory.description') },
  },
  {
    id: 'preferences', icon: Palette,
    get label() { return i18n.t('accountPages:modules.preferences.label') },
    get description() { return i18n.t('accountPages:modules.preferences.description') },
  },
  {
    id: 'notifications', icon: Bell,
    get label() { return i18n.t('accountPages:modules.notifications.label') },
    get description() { return i18n.t('accountPages:modules.notifications.description') },
  },
  {
    id: 'shortcuts', icon: Keyboard,
    get label() { return i18n.t('accountPages:modules.shortcuts.label') },
    get description() { return i18n.t('accountPages:modules.shortcuts.description') },
  },
]
